import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useQuery } from "@tanstack/react-query";
import { getAllSections } from "actions/survey/surveyAction";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiBolerplate from "utils/_helpers/apiBolerplate";

export const sectionStyle = makeStyles((theme) => ({
  sectionMainContainer: {
    borderRight: "2px solid #e9e9e9",
  },
  sectionContainer: {
    border: `1px solid var(--scroll-box-border-color)`,
    borderRadius: 8,
    height: "calc(100vh - 250px)",
    overflowX: "auto",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 10,
      height: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#fbfbfb",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#e9e9e9",
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#bbbbbb",
    },
  },
  sectionList: {
    fontSize: 14,
    fontWeight: 600,
    padding: "14px 8px",
    wordBreak: "break-all",
    backgroundColor: "#fafafa",
    cursor: "pointer",
    marginBottom: "10px",
    borderRadius: "6px",
  },
  sectionListHover: {
    border: "1px solid #96b8df",
    backgroundColor: "#ebf1f8",
  },
  heading: {
    fontWeight: 600,
    marginLeft: 10,
    marginTop: 10,
  },
}));

function SectionsList({
  selectedSection,
  handleSectionChangeSave,
  isLoggedIn,
}) {
  const classes = sectionStyle();
  const { data: allSections } = useQuery({
    queryKey: ["sections", isLoggedIn?.access_token, isLoggedIn?.survey_id],
    queryFn: async (data) => {
      const response = await apiBolerplate({
        url: "shared_survey/get_all_sections_for_survey_submission",
        bodyData: {
          survey_id: isLoggedIn?.survey_id,
          access_token: isLoggedIn?.access_token,
        },
        hideLoader: true,
        hideMsg: true,
      });

      if (Object.keys(selectedSection).length === 0)
        handleSectionChangeSave(response?.result[0]);

      return response;
    },
    enabled: !!isLoggedIn?.survey_id && !!isLoggedIn?.access_token,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return (
    <Box
      width={"20%"}
      className={classes.sectionMainContainer}
      sx={{ pointerEvents: "none" }}
    >
      <Typography className={classes.heading}>Sections</Typography>
      <Box m={1} className={classes.sectionContainer}>
        {allSections?.result.map(
          (sec) =>
            (sec?.resolvedConditionalLogic ?? true) && (
              <Typography
                onClick={() => handleSectionChangeSave(sec)}
                className={
                  sec?._id === selectedSection?._id
                    ? [classes.sectionList, classes.sectionListHover]
                    : classes.sectionList
                }
              >
                {sec?.title}
              </Typography>
            )
        )}
      </Box>
    </Box>
  );
}

export default SectionsList;
